import {
  UpdateField,
  FetchMobileUsersRequest,
  DeleteMobileUserRequest,
  SetDefaultData,
} from './mobile-users.actions'
import { getMobileUsersState } from './mobile-users.selectors'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'
import ListTrait from 'src/app/traits/list.trait'
import { Subscription, of } from 'rxjs'
import { Map, fromJS } from 'immutable'
import { TranslateService } from '@ngx-translate/core'
import { filtersToDbQuery } from '@shared/shared.utils'
import { TableFilterType } from '@shared/shared.types'

@Component({
  selector: 'app-mobile-users',
  templateUrl: './mobile-users.component.html',
  styleUrls: ['./mobile-users.component.css'],
})
export class MobileUsersComponent
  extends ListTrait
  implements OnInit, OnDestroy
{
  private state$: Subscription
  private route$: Subscription
  private shouldReload: boolean = false
  public isLoading: boolean = false
  public columns: object[] = []
  public filters: any[]

  constructor(
    private store: Store<any>,
    public router: Router,
    private route: ActivatedRoute,
    private translateService: TranslateService,
  ) {
    super(router)

    this.columns = [
      {
        prop: 'fullName',
        name: 'NAME',
        sortable: false,
        filterable: true,
        filterType: TableFilterType.String,
        hidden: true,
      },
      {
        prop: 'username',
        name: 'USERNAME',
        sortable: true,
        filterable: true,
        filterType: TableFilterType.String,
      },
      {
        prop: 'firstName',
        name: 'FIRST_NAME',
        sortable: true,
      },
      {
        prop: 'lastName',
        name: 'LAST_NAME',
        sortable: true,
      },
      {
        prop: 'layerFeatures',
        name: 'ZONES',
        sortable: false,
        template: 'zones',
      },
      {
        prop: 'suspended',
        name: 'SUSPENDED',
        template: 'suspended',
        filterable: true,
        filterType: TableFilterType.Boolean,
        select$: of(
          fromJS([
            { name: 'YES', title: 'Yes', translationKey: 'YES' },
            { name: 'NO', title: 'No', translationKey: 'NO' },
          ]),
        ),
      },
      {
        prop: 'activation',
        name: 'ACTIVATION_CODE',
        render: (row: any) => (row ? row.get('activationCode') : ''),
      },
      {
        prop: 'mode',
        name: 'MODE',
        template: 'mode',
      },
      {
        width: '162px',
        name: '',
        template: 'actionsColumn',
      },
    ]
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('list'))
    this.state$ = this.store
      .pipe(select(getMobileUsersState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
        this.filters = state.get('filters')?.toJS() ?? []

        if (
          state.get('shouldReload') !== this.shouldReload &&
          state.get('shouldReload')
        ) {
          this.handleFilterChange()
        }
        this.shouldReload = state.get('shouldReload')
      })

    this.route$ = this.route.queryParams.subscribe((params) => {
      this.handleFilterChange(params)
    })
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.route$.unsubscribe()
  }

  handleFilterChange(data?: any) {
    const filters = data?.filters ?? this.filters ?? []
    const pagination = data?.pagination ?? this.state.get('pagination')?.toJS() ?? { page: 1, page_size: 20, sort: '', order_by: '' }
    const { page, page_size, sort, order_by } = pagination

    this.store.dispatch(new UpdateField('filters', filters, 'list'))
    this.store.dispatch(new UpdateField('pagination', pagination, 'list'))

    const dbFilters: any = filtersToDbQuery(filters)

    // Convert 'YES'/'NO' to boolean for suspended filter
    if (dbFilters.matchOr) {
      dbFilters.matchOr = dbFilters.matchOr.map((filter: any) => {
        if (filter.field === 'suspended' && typeof filter.value === 'string') {
          return { ...filter, value: filter.value === 'YES' }
        }
        return filter
      })
    }

    if (dbFilters.matchAnd) {
      dbFilters.matchAnd = dbFilters.matchAnd.map((filter: any) => {
        if (filter.field === 'suspended' && typeof filter.value === 'string') {
          return { ...filter, value: filter.value === 'YES' }
        }
        return filter
      })
    }

    this.store.dispatch<any>(
      new FetchMobileUsersRequest({
        filters: dbFilters,
        pageSize: parseInt(page_size, 10),
        page: parseInt(page, 10) - 1,
        sort: {
          order: sort?.toUpperCase(),
          prop: order_by,
        },
      }),
    )
  }

  deleteUser(id: number) {
    this.store.dispatch(new DeleteMobileUserRequest(id))
  }
}
